export default __webpack_public_path__ + "static/margaryta-rovna-658956387c947cdbf47f0cb93113eaf0.png";